import { render, staticRenderFns } from "./ElFeaturedPostInfo.vue?vue&type=template&id=292f69a0"
import script from "./ElFeaturedPostInfo.vue?vue&type=script&lang=js"
export * from "./ElFeaturedPostInfo.vue?vue&type=script&lang=js"
import style0 from "./ElFeaturedPostInfo.vue?vue&type=style&index=0&id=292f69a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports